export default {
    analytics: 'analytics',
    marginality_analysis: 'marginality_analysis',
    advertising: 'advertising',
    ordersAndSales: 'orders-and-sales',
    prices: 'prices',
    stock: 'stock',
    returnAndCancellations: 'returns_cancellations',
    abc: 'ABCXYZ',
    lowHigh: 'low-high',
    brand_report: 'brand_report',
    slices: 'slices'
}